import React, { useState, useRef } from "react"
import withStyles from "react-jss"
import * as axios from "axios"
import colors from "../data/colors"

const styles = {
  emailContainer: {
    width: "100%",
    marginTop: "3rem",
    marginBottom: "2rem",
  },
  emailForm: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    // alignItems: "center",
    flexDirection: "column",
    "@media only screen and (max-width: 520px)": {
      alignItems: "flex-start",
    },
  },
  emailText: {
    display: "inline-block",
    fontSize: "calc(14px + (18 - 14) * ((100vw - 300px) / (1600 - 300)))",
    fontFamily: "Apercu",
    fontWeight: 400,
    marginBottom: "0.5rem",
    lineHeight: 1.4,
  },
  emailInput: {
    height: "40px",
    fontFamily: "Apercu",
    fontWeight: 400,
    fontSize: "calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)))",
    border: `2px solid black`,
    paddingLeft: "1rem",
    paddingRight: "1rem",
    width: "100%",
    maxWidth: "280px",
    minWidth: "220px",
    textAlign: "left",
    marginBottom: "0",
    "&::placeholder": {
      fontFamily: "Apercu",
      fontWeight: 400,
      fontSize: "calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)))",
      textAlign: "left",
    },
    "@media only screen and (max-width: 400px)": {
      maxWidth: "80%",
    },
  },
  emailButton: {
    height: "46px",
    marginTop: "8px",
    fontFamily: "WiredMono",
    fontWeight: 400,
    fontSize: "12px",
    padding: "0.5rem 1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: "black",
    border: `2px solid black`,
    width: "100%",
    maxWidth: "280px",
    minWidth: "220px",
    color: "white",
    transition: `background-color 0.2s ease-in-out,
      color 0.2s ease-in-out`,
    "&:hover": {
      color: "white",
      backgroundColor: colors.buttonBlue,
    },
    "&:focus": {
      color: "white",
      backgroundColor: colors.buttonBlue,
    },
  },
  emailError: {
    fontFamily: "Apercu",
    fontWeight: 400,
    fontSize: "calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)))",
    paddingTop: 5,
    color: "red",
    marginBottom: "0.5rem",
  },
}

const NewsletterSignup = ({ classes }) => {
  const [emailResponse, setEmailResponse] = useState("")
  const emailValue = useRef("")

  const handleSubmit = (e) => {
    const userEmail = emailValue.current
    e.preventDefault()
    sendEmail(userEmail.value)
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: `datavisualization-wiredHeadphoneQuiz-newsletterSubscribe`,
      })
    }
  }

  const sendEmail = async (email) => {
    try {
      setEmailResponse(
        await axios.post(
          "https://wired.com/api/up/v2/newsletter-subscriptions",
          {
            email: email,
            formName: "WIREDHeadphonesQuiz",
            partnerCode: "PARTNER_CODE",
            provider: "sailthru",
            siteCode: "NIL",
            sourceCode: "HeadphoneQuiz",
            subscriptions: [
              {
                status: "SUBSCRIBED",
                newsletterId: 248888,
              },
            ],
            url: "http://wired.com/story/headphones-quiz",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "x-client": "Verso-Wired",
            },
          }
        )
      )
    } catch (err) {
      // console.log(err)
      setEmailResponse("error")
    }
  }

  return (
    <div className={classes.emailContainer}>
      <label htmlFor="email" className={classes.emailText}>
        Subscribe to our free newsletter to get more awesome recommendations for
        the audiophile in your life.
      </label>
      <form className={classes.emailForm}>
        {" "}
        <input
          ref={emailValue}
          className={classes.emailInput}
          onFocus={() => (emailValue.current.value = "")}
          type="email"
          id="email"
          required=""
          name="email"
          placeholder="Your e-mail address"></input>
        <div>
          {" "}
          <button
            className={classes.emailButton}
            type="submit"
            onClick={handleSubmit}>
            {emailResponse && emailResponse.status === 201
              ? "SUSBSCRIBED!"
              : emailValue === ""
              ? "SIGN UP NOW"
              : "SIGN UP NOW"}
          </button>
        </div>
        <div className={classes.emailError}>
          {emailResponse && emailResponse === "error"
            ? "Please enter a valid email address."
            : null}
        </div>
      </form>
    </div>
  )
}

export default withStyles(styles)(NewsletterSignup)
